/**
 * Credit score related reducers
 */
import * as Actions from './actions';
var defaultCreditScore = 0;
export var creditScore = function creditScore() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultCreditScore;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case Actions.RECEIVE_CREDIT_SCORE:
      return action.creditScore ? action.creditScore : defaultCreditScore;

    default:
      return state;
  }
};